var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"config-button-container"},[_c('el-button',{attrs:{"circle":true,"size":"small"},on:{"click":_vm.click}},[_c('svg-icon',{attrs:{"name":"config"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }